// @flow
import React from "react";
import SecurityGuards from "../../../svg/facilities/has_security_guards.svg";
import "./securityGuardsIcon.scss";

const SecurityGuardsIcon = () => (
  <SecurityGuards className="c-security-guards-icon" />
);

export default SecurityGuardsIcon;
